/**
 * Centralized API Configuration
 *
 * Single source of truth for gateway URL and service endpoint construction.
 * Eliminates duplicate GATEWAY_URL definitions across 9+ files.
 */

export const GATEWAY_URL =
  process.env.REACT_APP_GATEWAY_URL
  || (process.env.REACT_APP_API_BASEURL ? `${process.env.REACT_APP_API_BASEURL}/api_gateway` : null)
  // Last resort only — CI always sets the variable above. Pointed at the custom
  // domain so even a misconfigured build stops advertising the region and
  // project id (ROADMAP: API behind api.indexalpha.ai).
  || 'https://api.indexalpha.ai/api_gateway';


// Requests are built by `services/gateway.ts` (`gatewayUrl`, `gatewayFetch`) —
// nothing else names this address (pinned by `__tests__/shapeRules.test.ts`).
